import { SpyneTrait, ChannelPayloadFilter } from 'spyne';

export class ChannelDeckTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'channelDeck$';
    super(context, traitPrefix);
  }

  static channelDeck$OnRegistered() {
    const deckResponseFilter = new ChannelPayloadFilter({
      action: 'CHANNEL_FETCH_DECK_RESPONSE_EVENT',
    });

    this.getChannel('CHANNEL_FETCH_DECK', deckResponseFilter).subscribe(
      this.channelDeck$OnFetchReturned.bind(this),
    );
  }

  // deck-schema.json carries its slides at the top level.
  static channelDeck$OnFetchReturned(e) {
    const deck = e.payload;
    const slides = deck?.slides ?? [];
    this.sendChannelPayload('CHANNEL_DECK_INIT_EVENT', { deck, slides });
  }
}
